module.exports = __webpack_public_path__ + "media/images/icons/forbidden-e1a8e7ff9dd1bd98d44a7e139c27c8a1.svg";